export default function CsharpInterface() {
  return (
    <h2>Csharp Interface</h2>
  );
}
